export interface Shelf {
  TreeId: number | null;
  ParentTreeId: number | null;
  Abbrev: string;
  Title: string;
  UniqueKey: string;
  isLeaf: boolean;
}

export const SHELF_INITIAL_VALUES: Shelf = {
  TreeId: null,
  ParentTreeId: null,
  Abbrev: "",
  Title: "",
  UniqueKey: "",
  isLeaf: false,
};
